import gql from "graphql-tag";

export default gql`
  query schoolOrDistrictOnboardingPrice(
    $numberOfSchools: Int!
    $discountCode: String
  ) {
    schoolOrDistrictOnboardingPrice(
      numberOfSchools: $numberOfSchools
      discountCode: $discountCode
    ) {
      startUpFeePerSchool
      discountRate
      totalAmount
    }
  }
`;



// WEBPACK FOOTER //
// ./src/Onboarding/Registration/onboarding/containers/Pricing/gql/schoolOrDistrictOnboardingPrice.query.js